<template>
  <AddressForm mode="edit" :addressId="id" />
</template>

<script>
import AddressForm from "@/components/page-components/Account/Address/AddressForm.vue";

export default {
  components: { AddressForm },
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  }
}
</script>

<style scoped>

</style>
